import React, { useState, useRef, useMemo } from 'react'
import PageLayout from '@layouts/PageLayout'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
import { Input, Table, Dropdown, message, Switch } from 'antd'
import Fetch from '@components/CRUD/Fetch'
import { EllipsisOutlined, PlusCircleOutlined } from '@ant-design/icons'
import Create from './Create'
import { client } from '@utils/client'
import Edit from './Edit'
import Button from '@components/Button'
import Text from '@components/Text'
import dayjs from 'dayjs'
import Delete from './Delete'

export const wellKidzClubECoupon = 'wellKidzClub.eCoupon'
export const wellKidzClubError = 'wellKidzClub.error'
export const wellKidzClubButton = 'wellKidzClub.button'
export const wellKidzClubModal = 'wellKidzClub.modal'
const componentsListOperation = 'components.listOperation'

const List = () => {
  const { t } = useLocalization()
  const defaultPage = 1
  const defaultPageSize = 10
  const fetchRef = useRef(null)
  const [page, setpage] = useState(defaultPage)
  const [pageSize, setpageSize] = useState(defaultPageSize)
  const [modalCreateOpen, setmodalCreateOpen] = useState(false)
  const [keyword, setKeyword] = useState()
  const [modalEditOpen, setModalEditOpen] = useState(false)
  const [modalConfirmDeleteOpen, setModalConfirmDeleteOpen] = useState(false)
  const [defaultValues, setDefaultValues] = useState({})
  const memoizedParams = useMemo(
    () => ({ page, pageSize, keyword }),
    [page, pageSize, keyword]
  )

  const columns = [
    {
      title: 'No.',
      key: 'order',
      width: 62,
      render: function get(_value, _record, index) {
        return <Text> {(page - 1) * defaultPageSize + index + 1}</Text>
      },
    },
    {
      title: t(`${wellKidzClubECoupon}.eCouponName`),
      dataIndex: 'name',
      key: 'name',
      width: 200,
    },
    {
      title: t(`${wellKidzClubECoupon}.benefitType`),
      // dataIndex: 'typePermissionCoupon',
      key: 'typePermissionCoupon',
      width: 100,
      render: function get(record) {
        const { typePermissionCoupon } = record

        if (typePermissionCoupon === 'Limit') {
          return <Text>{t(`${wellKidzClubECoupon}.limited`)}</Text>
        } else {
          return <Text>{t(`${wellKidzClubECoupon}.unlimited`)}</Text>
        }
      },
    },
    {
      title: t(`${wellKidzClubECoupon}.remainingQuota`),
      key: 'balance',
      width: 100,
      render: function get(record) {
        const { remaining, typePermissionCoupon, typePermissionCouponLimit } =
          record

        if (typePermissionCoupon === 'Limit') {
          return (
            <Text>
              {`${remaining} ${t(`${wellKidzClubECoupon}.of`)}  ${
                typePermissionCouponLimit || 0
              }`}
            </Text>
          )
        } else {
          return <Text>-</Text>
        }
      },
    },
    {
      title: t(`${wellKidzClubECoupon}.usageLimit`),
      key: 'limitInUse',
      width: 100,
      render: function get(record) {
        const { limitInUse } = record
        switch (limitInUse) {
          case 'one_account':
            return <Text>{t(`${wellKidzClubECoupon}.oneTimePerAccount`)}</Text>
          case 'one_day':
            return <Text>{t(`${wellKidzClubECoupon}.oneTimePerDay`)}</Text>
          case 'one_month':
            return <Text>{t(`${wellKidzClubECoupon}.oneTimePerMonth`)}</Text>
          default:
            return <Text>-</Text>
        }
      },
    },
    {
      title: t(`${wellKidzClubECoupon}.date`),
      key: 'expiredAt',
      width: 140,
      render: function get(record) {
        const { startAt, expiredAt } = record
        return (
          <Text>
            {dayjs(startAt).locale('th').format('DD MMM YYYY')}
            {' - '}
            {dayjs(expiredAt).locale('th').format('DD MMM YYYY')}
          </Text>
        )
      },
    },

    {
      title: t(`${wellKidzClubECoupon}.couponActivation`),
      key: 'expiredAt',
      width: 100,
      render: function get(record) {
        const { id, isOpen } = record
        return (
          <div style={{ display: 'flex', gap: 8 }}>
            {t(`${componentsListOperation}.close`)}
            <Switch defaultChecked={isOpen} onChange={(e) => onChange(e, id)} />
            {t(`${componentsListOperation}.open`)}
          </div>
        )
      },
    },

    {
      title: '',
      key: 'edit',
      width: 61,
      render: function couponEvent(record) {
        const items = [
          {
            key: '1',
            label: (
              <a
                onClick={() => {
                  setModalEditOpen(true)
                  setDefaultValues(record)
                }}
              >
                <Text type="primary">
                  {t(`${componentsListOperation}.edit`)}
                </Text>
              </a>
            ),
          },
          {
            type: 'divider',
          },
          {
            key: '2',
            label: (
              <a
                onClick={() => {
                  setModalConfirmDeleteOpen(true)
                  setDefaultValues(record)
                }}
              >
                <Text type="primary">
                  {t(`${componentsListOperation}.delete`)}
                </Text>
              </a>
            ),
          },
          {
            type: 'divider',
          },
          {
            key: '3',
            label: (
              <a
                onClick={() => {
                  onDownload(record)
                }}
              >
                <Text type="primary">
                  {t(`${wellKidzClubButton}.downloadReport`)}
                </Text>
              </a>
            ),
          },
        ]
        return (
          <>
            <div>
              <Dropdown
                menu={{
                  items,
                }}
                trigger="click"
              >
                <EllipsisOutlined
                  style={{ fontSize: '32px', color: '#005596' }}
                />
              </Dropdown>
            </div>
          </>
        )
      },
    },
  ]
  const onDownload = async (coupon) => {
    const { data } = await client.get(`/coupons/${coupon.id}/excel`, {
      responseType: 'blob',
    })

    const fileName = `รายงานคูปอง-${coupon.name.substring(0, 150)} ${
      coupon.name.length > 150 ? '...' : ''
    }.xlsx`
    const url = window.URL.createObjectURL(new Blob([data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `รายงานคูปอง-${fileName}.xlsx`)
    document.body.appendChild(link)
    link.click()
  }
  const fetch = async ({ page, pageSize }) => {
    const result = await client
      .get('/coupons', {
        params: {
          page: page,
          size: pageSize,
          keyword: keyword,
        },
      })
      .then((res) => res.data)
    return result
  }
  const onChange = async (checked, id) => {
    try {
      await client.patch(`/coupons/${id}/toggle-status`)
    } catch (e) {
      message.error('ไม่สำเร็จ')
    }
  }

  const handleReload = () => {
    fetchRef.current.reload()
  }
  const onDelete = async () => {
    try {
      await client.delete(`/coupons/${defaultValues.id}`)
      message.success(t('promotion.list.deleteSuccess'))
      setModalConfirmDeleteOpen(false)
      handleReload()
    } catch (e) {
      message.error(t('promotion.list.deleteeFailed'))
    }
  }

  const handleChange = (pagination) => {
    setpage(pagination.current)
    setpageSize(pagination.pageSize)
  }

  const style = {
    btn: { borderRadius: '5px', width: '165px', height: '40px' },
    divSearch: {
      width: '100%',
      display: 'flex',
      gap: '20px',
      marginBottom: '20px',
    },
    btnSearch: { borderRadius: '5px', width: '136px', height: '40px' },
    inputSearch: { width: '100%', borderRadius: '6px', height: '40px' },
  }

  return (
    <>
      <Fetch fetch={fetch} params={memoizedParams} ref={fetchRef}>
        {({ data, total }) => (
          <>
            <PageLayout
              title={t(`${wellKidzClubECoupon}.title`)}
              shownBack={false}
              extra={[
                <Button
                  type="primary"
                  key="btnAddData"
                  icon={<PlusCircleOutlined style={{ fontSize: 18 }} />}
                  onClick={() => setmodalCreateOpen(true)}
                  style={style.btn}
                >
                  {t(`${wellKidzClubButton}.addData`)}
                </Button>,
              ]}
            >
              <div style={style.divSearch}>
                <SearchInput
                  keywordValue={keyword}
                  fetchData={(keyword) => setKeyword(keyword)}
                />
              </div>

              <Table
                rowKey="id"
                columns={columns}
                dataSource={data}
                onChange={handleChange}
                pagination={{
                  defaultCurrent: defaultPageSize,
                  defaultPageSize: defaultPageSize,
                  current: page,
                  pageSize,
                  total,
                }}
              ></Table>
            </PageLayout>
          </>
        )}
      </Fetch>
      {modalCreateOpen && (
        <Create
          open={modalCreateOpen}
          setOpen={setmodalCreateOpen}
          reload={handleReload}
        />
      )}
      {modalEditOpen && (
        <Edit
          open={modalEditOpen}
          setOpen={setModalEditOpen}
          defaultValues={defaultValues}
          reload={handleReload}
        />
      )}
      {modalConfirmDeleteOpen && (
        <Delete
          open={modalConfirmDeleteOpen}
          setOpen={setModalConfirmDeleteOpen}
          onDelete={onDelete}
        />
      )}
    </>
  )
}
const SearchInput = ({ fetchData, keywordValue }) => {
  const { t } = useLocalization()
  const [keyword, setKeyword] = useState()
  const style = {
    btnSearch: { borderRadius: '5px', width: '136px', height: '40px' },
    inputSearch: { width: '100%', borderRadius: '6px', height: '40px' },
  }

  return (
    <>
      <Input
        defaultValue={keywordValue || keyword}
        placeholder={t(`${wellKidzClubECoupon}.eCouponName`)}
        style={style.inputSearch}
        onChange={(e) => setKeyword(e.target.value)}
      />

      <Button
        style={style.btnSearch}
        type="primary"
        key="reload"
        onClick={() => fetchData(keyword)}
      >
        {t(`${wellKidzClubButton}.search`)}
      </Button>
    </>
  )
}

SearchInput.propTypes = {
  fetchData: PropTypes.func,
  keywordValue: PropTypes.string,
}
export default List
